import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Card, ImageAssetFactory } from '../../domain/card';
import { ImageAsset, ImageAssetType } from '../../domain/types';
import { I18nKeys } from '@jump-tech-frontend/app-config';

import { QuestionsComponent } from '../../core/questions.component';
import { ImageAssetComponent } from '../../core/image-asset.component';

@Component({
  selector: `crds-default-form`,
  template: `
    <div class="card-wrapper">
      <div class="card__title-header">
        <div class="card__title">{{ card.label }}</div>
        <div class="card__step">{{ card.stepProgress }}</div>
      </div>
    
      <div class="card__description">
        <p class="card-text" [innerHTML]="card.description" [attr.data-qa]="'description'"></p>
        <crds-image-asset [images]="images" [key]="'default'"></crds-image-asset>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="form.get(formKey)">
        <crds-questions
          [form]="form.get(formKey)"
          [card]="card"
          [i18ns]="i18ns"
          [useJuiControls]="useJuiControls"
          [deviceContext]="deviceContext"
        ></crds-questions>
      </form>
    </div>
    @if (card.description2) {
      <div class="card-wrapper">
        <div class="card">
          <div class="card-body">
            <p class="card-text" [innerHTML]="card.description2"></p>
          </div>
        </div>
      </div>
    }
    `,
  imports: [ImageAssetComponent, ReactiveFormsModule, QuestionsComponent]
})
export class DefaultFormComponent implements OnChanges {
  @Input() card: Card<null>;
  @Input() form: UntypedFormGroup;
  @Input() formKey: string;
  @Input() i18ns: I18nKeys;
  @Input() useJuiControls?: boolean = false;
  @Input() deviceContext?: string = 'desktop';

  action: any;
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(private imageAssetFactory: ImageAssetFactory) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.card || !Object.prototype.hasOwnProperty.call(changes, 'card')) {
      return;
    }

    this.action = this.card.action;
    if (changes['card'] && changes['card'].firstChange) {
      // prevent reloading flicker of image when forms change R.B
      this.images = this.imageAssetFactory.create(this.card.image, this.form);
    }
  }
}
